import { FC } from 'react';
import { Navigate, useParams } from 'react-router';

/**
 * The Actions page became a tab of Files. Keeps old links and bookmarks working.
 *
 * Builds an absolute path deliberately: relative `..` resolution out of a param route is
 * easy to get subtly wrong, and there is nothing to gain from relying on it here.
 */
export const ActionsRedirect: FC = () => {
  const { projectId, botId } = useParams();
  return <Navigate to={`/${projectId}/${botId}/files/actions`} replace />;
};
